// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const idnr: CountryValidator<"DE"> = createValidator(
  "de.idnr",
  52,
);

export default idnr;
export const compact = idnr.compact;
export const format = idnr.format;
export const validate = idnr.validate;
export const generate = (): string =>
  idnr.generate?.() ??
  (() => {
    throw new Error(
      "Validator de.idnr cannot generate values",
    );
  })();
